export const FETCH_PROJECT_ACCESS_TYPES = 'FETCH_PROJECT_ACCESS_TYPES';
export const FETCH_PROJECT_ACCESS_TYPES_SUCCESS = 'FETCH_PROJECT_ACCESS_TYPES_SUCCESS';
export const FETCH_PROJECT_ACCESS_TYPES_FAIL = 'FETCH_PROJECT_ACCESS_TYPES_FAIL';
export const SET_PROJECT_ACCESS_TYPE = 'SET_PROJECT_ACCESS_TYPE';
